const actions = {
  SET_QUOTA_CREDITS_WIDGET_DATA: 'SET_QUOTA_CREDITS_WIDGET_DATA',
  SET_CURRENT_WIDGET_USER: 'SET_CURRENT_WIDGET_USER',
  SET_PRODUCT_EXPIRY_DATA: 'SET_PRODUCT_EXPIRY_DATA',
  SET_QUOTA_CREDITS_WIDGET_ERROR_LOADING: 'SET_QUOTA_CREDITS_WIDGET_ERROR_LOADING',
};
export default actions;
